import { useRive } from '@rive-app/react-canvas';

import { Button } from '../../../lib/button';
import formatPhoneNumber from '../../../utils/formatPhoneNumber';
import riveConfig from './riveConfig';
import CallDuration from './CallDuration';
import { CallInfoProps } from '../types';
import { keys } from '../helpers';

const CallInfo: React.FC<CallInfoProps> = ({
    call,
    phone,
    personName,
    showRingingDots,
    startTimer,
    showDuration,
    showKeys
}) => {
    const { RiveComponent } = useRive(riveConfig);

    return (
        <>
            <div>
                <div className="flex justify-between items-center text-lg font-bold">
                    {personName && <span>{personName}</span>}
                    {showRingingDots && (
                        <div className="w-8 h-6">
                            <RiveComponent />
                        </div>
                    )}
                    {showDuration && <CallDuration startTimer={startTimer} />}
                </div>
                <p className="text-gray-400 text-sm">{formatPhoneNumber(phone)}</p>
            </div>
            {showKeys && (
                <div className="grid grid-cols-3 mt-6 mb-3">
                    {keys.map((key) => (
                        <Button
                            key={key}
                            variant="outline-dark"
                            className="-mt-px -mr-px rounded-none h-16 text-2xl font-bold first:rounded-tl-2xl last:rounded-br-2xl [&:nth-of-type(3)]:rounded-tr-2xl [&:nth-of-type(10)]:rounded-bl-2xl"
                            onClick={() => call?.sendDigits(key)}
                        >
                            {key}
                        </Button>
                    ))}
                </div>
            )}
        </>
    );
};
export default CallInfo;
